import { Link, NavLink, useNavigate, useParams } from 'react-router-dom';
import { Bell, Coins, Gift, Languages, Menu, MessageCircle, ShieldCheck, User, Zap } from 'lucide-react';
import { detectLang, langs } from '../lib/i18n';

export function Shell({children}:{children:React.ReactNode}) {
  const params = useParams();
  const navigate = useNavigate();
  const lang = params.lang || detectLang();
  const zh = lang === 'zh';
  const switchLang = (next:string) => {
    localStorage.setItem('lang', next);
    navigate(location.pathname.replace(/^\/(en|zh|es|ru|tg)/, `/${next}`));
  };
  const nav = [
    [zh ? '大厅' : 'Lobby', `/${lang}`],
    [zh ? '热门卡池' : 'Box Pools', `/${lang}/boxes`],
    [zh ? '稀有奖励' : 'Rare Loot', `/${lang}/recent-wins`],
    [zh ? '开盒记录' : 'Draw Logs', `/${lang}/recent-wins`],
    [zh ? '任务中心' : 'Missions', `/${lang}/account/referrals`],
    [zh ? '帮助' : 'Help', `/${lang}/help`],
  ];
  return <div className="arena-shell">
    <header className="sticky top-0 z-40 h-[72px] border-b border-[rgba(124,92,255,.22)] bg-[rgba(7,11,23,.78)] backdrop-blur-2xl">
      <div className="mx-auto flex h-full max-w-[1440px] items-center justify-between gap-3 px-4">
        <Link to={`/${lang}`} className="flex min-w-0 items-center gap-3">
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl border border-[rgba(246,199,106,.35)] bg-[rgba(246,199,106,.12)] text-[#F6C76A]"><Gift size={23}/></span>
          <span className="hidden leading-tight sm:block"><b className="block text-[15px] text-[#F4F7FF]">Mystery Box Arena</b><small className="text-[#A7B0C0]">Cyber Loot Box Game Lobby</small></span>
        </Link>
        <nav className="hidden items-center gap-1 lg:flex">{nav.map(([label,to])=><NavLink key={to+label} to={to} className="rounded-2xl px-3 py-2 text-sm text-[#A7B0C0] hover:bg-white/5 hover:text-[#F4F7FF]">{label}</NavLink>)}</nav>
        <div className="flex items-center gap-2">
          <div className="hidden items-center gap-2 rounded-2xl border border-[rgba(246,199,106,.24)] bg-[rgba(246,199,106,.1)] px-3 py-2 text-sm font-black text-[#F6C76A] md:flex"><Coins size={16}/> 0.00 USDT</div>
          <button className="icon-btn hidden sm:inline-flex"><Bell size={18}/></button>
          <div className="hidden items-center gap-2 md:flex"><Languages size={17}/><select className="rounded-xl border border-[rgba(124,92,255,.28)] bg-[#10182B] px-2 py-2 text-sm text-[#F4F7FF]" value={lang} onChange={e=>switchLang(e.target.value)}>{langs.map(l=><option key={l}>{l}</option>)}</select></div>
          <Link className="icon-btn" to={`/${lang}/account`}><User size={18}/></Link>
          <button className="icon-btn lg:hidden"><Menu size={18}/></button>
        </div>
      </div>
    </header>
    {children}
  </div>;
}

const menus = ['Dashboard','Mystery Boxes','Prizes','Users','Verification','Orders','Payments','Referrals','Withdrawals','Shipping','Support','Homepage','Content','Settings','Risk Control','System'];
export function AdminShell({children}:{children:React.ReactNode}) {
  return <div className="min-h-screen bg-[#070B17] text-[#F4F7FF] md:flex">
    <aside className="sticky top-0 z-20 h-auto border-r border-[rgba(124,92,255,.2)] bg-[rgba(10,16,31,.9)] p-4 backdrop-blur-xl md:h-screen md:w-72">
      <div className="mb-6 flex items-center gap-3 text-lg font-black"><ShieldCheck className="text-[#F6C76A]"/> Game Ops Admin</div>
      <nav className="grid gap-1">{menus.map(m=><NavLink key={m} className="rounded-2xl px-3 py-2 text-sm text-[#A7B0C0] hover:bg-white/5 hover:text-[#F4F7FF]" to={`/admin/${m.toLowerCase().replaceAll(' ','-')}`}>{m}</NavLink>)}</nav>
    </aside>
    <main className="flex-1">
      <div className="sticky top-0 z-10 flex items-center justify-between border-b border-[rgba(124,92,255,.18)] bg-[rgba(7,11,23,.82)] px-4 py-3 backdrop-blur-xl">
        <button className="icon-btn"><Menu size={18}/></button>
        <div className="flex items-center gap-3 text-sm text-[#A7B0C0]"><Zap className="text-[#36C5FF]" size={18}/> Game Operations Admin Dashboard <MessageCircle size={18}/></div>
      </div>
      <div className="p-4 md:p-8">{children}</div>
    </main>
  </div>;
}
